<template>
  <div class="authstr-container">
    <header>
      <span class="title">授权码</span>
      <div class="right">
        <el-input class="seach" size="small" v-model="searchInput" placeholder="请输入" suffix-icon="el-icon-search" @keyup.enter.native="search"></el-input>
        <el-button type="primary" @click="add">新增</el-button>
      </div>
    </header>
    <el-table :data="tableList" tooltip-effect="dark" style="width: 100%" class="el-table-01">
      <el-table-column prop="code" label="授权码" min-width="120"></el-table-column>
      <el-table-column prop="application_name" label="授权应用名称" :show-overflow-tooltip="true" min-width="200"></el-table-column>
      <el-table-column prop="type" label="类型" min-width="100">
        <template slot-scope="scope">
          {{scope.row.code_type === 1 ? "永久性":"一次性"}}
        </template>
      </el-table-column>
      <el-table-column prop="use_count" label="已使用次数" min-width="100"></el-table-column>
      <el-table-column label="操作" min-width="100">
        <template slot-scope="scope">
          <span class="operator-btn" @click="edit(scope.row)">编辑</span>
          <span class="operator-btn" @click="del(scope.row)">删除</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change='handleSizeChange' @current-change='handleCurrentChange' :current-page='pageNum' :page-sizes='[10, 20, 50, 100]' :page-size='pageSize' layout='total, sizes, prev, pager, next, jumper' :total='tableTotal'></el-pagination>

    <div class="mask n1" v-if="dialogAdd" @click="dialogAdd = false"></div>
    <transition name="slide">
      <el-container class="add-dialog component-add-dialog" v-if="dialogAdd">
        <header>
          <span>{{form.id?'编辑':'添加'}}</span>
          <i class="iconfont icon-close" @click="dialogAdd = false"></i>
        </header>
        <div class="content">
          <div class="banner">
            <div class="h1">授权码</div>
          </div>
          <div class="form">
            <div class="form-header">基本信息</div>
            <div class="form-content">
              <div class="form-item single">
                <span class="item-title"><span class="need">*</span>授权码</span>
                <div class="item-right">
                  <el-input v-model="form.code" placeholder="请输入(必填)" size="medium" class="append_primary" maxlength="10" :disabled="!!form.id">
                    <template slot="append" v-if="!form.id">
                      <div class="primary" @click="generate">自动生成</div>
                    </template>
                  </el-input>
                </div>
                <div class="err" v-if="err.code"><i class="el-icon-warning"></i>{{err.code}}</div>
              </div>
              <div class="form-item single">
                <span class="item-title item-title2"><span><span class="need">*</span>授权</span><span>应用名称</span></span>
                <div class="item-right">
                  <el-select v-model="form.applicationId" multiple placeholder="请选择(必填)" filterable collapse-tags size="medium" style="height: auto;">
                    <el-option v-for="item in appList" :key="item.id" :label="item.template_name" :value="item.id"></el-option>
                  </el-select>
                </div>
                <div class="err" v-if="err.application"><i class="el-icon-warning"></i>{{err.application}}</div>
              </div>
              <div class="form-item single">
                <span class="item-title"><span class="need">*</span>类型</span>
                <div class="item-right">
                  <el-select v-model="form.codeType" placeholder="请选择(必填)" size="medium">
                    <el-option v-for="item in typeList" :key="item.id" :label="item.label" :value="item.id"></el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer>
          <el-button @click="dialogAdd = false">取 消</el-button>
          <el-button type="primary" @click="dialogSave">保 存</el-button>
        </footer>
      </el-container>
    </transition>
  </div>
</template>
<script>
export default {
  data () {
    return {
      searchInput: '',
      tableList: [],
      pageSize: 20,
      pageNum: 1,
      tableTotal: 0,
      multipleSelection: [],
      form: {
        code: '',
        applicationId: [],
        codeType: 0,
        note: ''
      },
      err: {
        code: '',
        application: ''
      },
      appList: [],
      typeList: [{'label': '一次性', 'id': 0}, {'label': '永久性', 'id': 1}],
      dialogAdd: false,
      dialogDelete: false,
      disabled: true
    }
  },
  mounted () {
    this.searchValue = ''
    this.getDataList()
  },
  methods: {
    /** 获取列表 */
    getDataList () {
      var jsondata = {'pageNum': this.pageNum, 'pageSize': this.pageSize, 'keyWord': this.searchValue}
      this.$http.queryAuthorizationCodeUserCountList(jsondata, 'Loading').then((res) => {
        this.tableList = res.dataList
        var pageInfo = res.pageInfo
        this.tableTotal = pageInfo.totalRows
      })
    },
    /** 搜索 */
    search () {
      this.searchValue = JSON.parse(JSON.stringify(this.searchInput))
      this.pageNum = 1
      this.pageSize = 20
      this.getDataList()
    },
    /** 显示每页条数 */
    handleSizeChange (val) {
      this.pageSize = val
      this.pageNum = 1
      this.getDataList()
    },
    /** 跳转第几页 */
    handleCurrentChange (val) {
      this.pageNum = val
      this.getDataList()
    },
    dialogSave () {
      if (!this.form.code) {
        this.err.code = '授权码不能为空'
        return
      }
      if (!/^[A-Za-z0-9]{9}$/.test(this.form.code)) {
        this.err.code = '授权码只能为9位'
        return
      }
      if (!this.form.applicationId.length) {
        this.err.application = '授权应用名称不能为空'
        return
      }
      let arr = this.form.applicationId.includes(0) ? [this.appList[0]] : this.appList.filter(v => this.form.applicationId.includes(v.id))
      let jsondata = {
        code: this.form.code,
        applicationId: arr.map(v => v.id).toString(),
        applicationName: arr.map(v => v.template_name).toString(),
        codeType: this.form.codeType
      }
      if (this.form.id) {
        jsondata.id = this.form.id
      }
      console.log(jsondata)
      this.$http.saveAuthorizationCode(jsondata, 'Loading').then((res) => {
        this.dialogAdd = false
        this.getDataList()
      })
    },
    // 自动生成
    generate () {
      if (this.form.id) {
        return
      }
      var str = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
      var result = ''
      for (var i = 9; i > 0; --i) result += str[Math.floor(Math.random() * str.length)]
      console.log(result)
      this.form.code = result
    },
    add () {
      this.err = {
        code: '',
        application: ''
      }
      this.form = {
        code: '',
        applicationId: [],
        codeType: 0
      }
      this.dialogAdd = true
      !this.appList.length && this.queryReleaseApplicationList()
    },
    edit (data) {
      this.err = {
        code: '',
        application: ''
      }
      let arr = data.application_id.split(/{|,|"|}/)
      let ids = []
      arr.map(v => {
        v && ids.push(parseInt(v))
      })
      this.form = {
        id: data.id,
        code: data.code,
        applicationId: ids,
        codeType: data.code_type
      }
      console.log(this.form)
      this.dialogAdd = true
      !this.appList.length && this.queryReleaseApplicationList()
    },
    // 获取应用列表
    queryReleaseApplicationList () {
      var jsondata = {'pageNum': 1, 'pageSize': 9999}
      this.$http.queryReleaseApplicationList(jsondata, 'Loading').then((res) => {
        let arr = [{id: 0, template_name: '全部'}]
        this.appList = [...arr, ...res.dataList]
      })
    },
    del (data) {
      this.$confirm('确定要删除该授权码吗？删除后将不可使用', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var jsondata = {'ids': data.id}
        this.$http.deleteAuthorizationCode(jsondata, 'Loading').then((res) => {
          this.pageNum = 1
          this.getDataList()
        })
      }).catch(() => {
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/application/authorization.vue